export class RegionModel {
    name: string;
    id: string;
    default: boolean;
}
